<template>
  <v-overlay v-if="!lazy && !dataReady && forceUnLoading!=true">
    <v-progress-circular indeterminate color="purple" size="70" width="7"></v-progress-circular>
  </v-overlay>
  <div v-else-if="!lazy && !dataReady && forceUnLoading"></div>
  <div v-else>
    <div v-if="!dataSource.length" class="text-h3 orange--text">暂无数据</div>
    <div v-else>
      <data-table :config="_config" :matrix="dataSource" />
    </div>
  </div>

</template>
<script>
/*
 在嵌入小工具中配置列:
--------------------------------------------------------------------------------
在小工具的 绘图数据参数 里面按照这种格式进行配置:
{"cols":[{"field":1},{"field":0,"visible":false}]}
说明:
cols: 配置需要的列(如果这里不配置,则点击右上角的图标的时候也不会出现)
field: 列的序号(从0开始)
visible: 是否默认显示(如果配置为不显示,可以通过右上角的列配置进行勾选切换是否显示某列)
--------------------------------------------------------------------------------
 */
import { userFileRead, userFileStream } from '@/plugins/api';
import DataTable from '@/views/Component/DataTable.vue';

export default {
  // paramValue: 参数表单使用
  props: ['forceUnLoading', 'lazy', 'paramValue', 'config', 'dataSourceParam', 'chartContainerId', 'status'],
  data () {
    return {
      dataSource: [],
      srs: [],
      dataReady: false
    }
  },
  components: { DataTable },
  async mounted () {
    try {
      await this.init();
    } finally {
      if (this.status) this.status.ready = true
    }
  },
  computed: {
    chartElId () { return this.chartContainerId || 'chartContainer' },
    _config () {
      let ret = this.config || {};
      if (!ret.tools) ret.tools = [];
      let downloadBtn = { name: '下载', color: 'primary', click: this.onExport };
      ret.tools.push(downloadBtn);
      return ret;
    }
  },
  methods: {
    async init () {
      if (!this.lazy) {
        this.dataReady = false;
        this.dataSource = []
        await userFileRead(this.dataSourceParam).then(res => {
          if (res) this.dataSource = res.data || []
        })
        this.dataReady = true;
      }
    },
    // =============== 文件下载
    onExport () {
      userFileStream(this.dataSourceParam);
    }
  }
}
</script>